export default "__VITE_ASSET__CbXAhwml__"